var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_vm._v(" 敌舰丢失(404) "),_c('router-link',{attrs:{"to":{name:'home'}}},[_vm._v("回到基地")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }